<!-- eslint-disable @angular-eslint/template/elements-content -->
<div
  class="min-h-screen w-full max-w-full overflow-x-hidden bg-white text-gray-950 lg:grid lg:grid-cols-[1.1fr_0.9fr] lg:overflow-hidden"
>
  <!-- ═══ LEFT PANEL (desktop only) ═══ -->
  <section
    class="relative hidden lg:flex flex-col justify-between px-12 py-10 overflow-hidden bg-[radial-gradient(circle_at_18%_18%,rgba(34,197,94,0.28),transparent_38%),radial-gradient(circle_at_85%_85%,rgba(6,182,212,0.16),transparent_42%),linear-gradient(135deg,#05100b_0%,#0b1d15_52%,#11201b_100%)] text-white"
  >
    <!-- Decorative grid + glow -->
    <div
      class="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:46px_46px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_75%)]"
    ></div>
    <div
      class="pointer-events-none absolute -top-24 -right-20 h-72 w-72 rounded-full bg-emerald-500/20 blur-3xl"
    ></div>
    <div
      class="pointer-events-none absolute bottom-10 -left-16 h-64 w-64 rounded-full bg-cyan-500/10 blur-3xl"
    ></div>

    <nav class="flex items-center justify-between relative z-10">
      <a routerLink="/" class="flex items-center gap-3">
        <span
          class="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 ring-1 ring-white/15 backdrop-blur"
        >
          <img src="/images/miyzan-logo.png" alt="MIYZAN" class="h-8 w-8 object-contain" />
        </span>
        <span class="text-2xl font-bold tracking-tight">MIYZAN</span>
      </a>
      <a
        routerLink="/"
        class="rounded-full border border-white/15 bg-white/5 px-5 py-2 text-sm text-emerald-50 hover:bg-white/10 hover:border-white/25 transition"
      >
        {{ 'LOGIN.HOME' | translate }}
      </a>
    </nav>

    <div class="relative z-10 max-w-xl space-y-8">
      <div
        class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-sm text-emerald-100 backdrop-blur"
      >
        <lucide-icon [img]="Sparkles" class="h-3.5 w-3.5 text-emerald-300"></lucide-icon>
        {{ 'LOGIN.BADGE' | translate }}
      </div>
      <div class="space-y-4">
        <h1 class="text-[3.25rem] font-bold leading-[1.08] tracking-tight">
          {{ 'LOGIN.LEFT_TITLE' | translate }}
        </h1>
        <p class="text-lg text-emerald-50/70 leading-8">
          {{ 'LOGIN.LEFT_SUB' | translate }}
        </p>
      </div>

      <!-- Feature list -->
      <ul class="space-y-3">
        <li class="flex items-center gap-3 text-emerald-50/85">
          <span
            class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-emerald-500/15 text-emerald-300"
          >
            <lucide-icon [img]="TrendingUp" class="h-4 w-4"></lucide-icon>
          </span>
          {{ 'LOGIN.FEATURE_1' | translate }}
        </li>
        <li class="flex items-center gap-3 text-emerald-50/85">
          <span
            class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-emerald-500/15 text-emerald-300"
          >
            <lucide-icon [img]="Boxes" class="h-4 w-4"></lucide-icon>
          </span>
          {{ 'LOGIN.FEATURE_2' | translate }}
        </li>
        <li class="flex items-center gap-3 text-emerald-50/85">
          <span
            class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-emerald-500/15 text-emerald-300"
          >
            <lucide-icon [img]="ShieldCheck" class="h-4 w-4"></lucide-icon>
          </span>
          {{ 'LOGIN.FEATURE_3' | translate }}
        </li>
      </ul>
    </div>

    <div
      class="relative z-10 rounded-2xl border border-white/10 bg-white/[0.07] p-6 shadow-2xl backdrop-blur-sm"
    >
      <div class="flex items-center justify-between border-b border-white/10 pb-4">
        <div>
          <p class="text-sm text-emerald-100/65">{{ 'LOGIN.STAT_TODAY' | translate }}</p>
          <p class="text-3xl font-bold mt-1">18 450 000 so'm</p>
        </div>
        <span
          class="inline-flex items-center gap-1 rounded-full bg-emerald-400/15 px-3 py-1 text-sm font-medium text-emerald-200"
        >
          <lucide-icon [img]="TrendingUp" class="h-3.5 w-3.5"></lucide-icon>+12%
        </span>
      </div>
      <div class="mt-5 grid grid-cols-4 gap-3 items-end">
        <div class="h-20 rounded-xl bg-gradient-to-t from-emerald-600/60 to-emerald-400/80"></div>
        <div class="h-28 rounded-xl bg-gradient-to-t from-cyan-500/60 to-cyan-300/80"></div>
        <div class="h-16 rounded-xl bg-gradient-to-t from-amber-500/60 to-amber-300/80"></div>
        <div class="h-24 rounded-xl bg-gradient-to-t from-white/50 to-white/80"></div>
      </div>
    </div>
  </section>

  <!-- ═══ RIGHT PANEL (form) ═══ -->
  <section
    class="relative flex min-h-screen items-center justify-center px-4 py-6 sm:px-5 sm:py-10 bg-[radial-gradient(circle_at_50%_0%,rgba(16,185,129,0.06),transparent_45%),linear-gradient(180deg,#ffffff_0%,#f8faf9_100%)]"
  >
    <div class="w-full max-w-[420px]">
      <!-- Mobile brand header -->
      <div class="mb-6 flex flex-col items-center text-center lg:hidden">
        <a
          routerLink="/"
          class="flex h-20 w-20 items-center justify-center rounded-[1.75rem] bg-white shadow-xl shadow-emerald-600/15 ring-1 ring-emerald-100"
        >
          <img src="/images/miyzan-logo.png" alt="MIYZAN" class="h-14 w-14 object-contain" />
        </a>
        <span class="mt-3 text-2xl font-bold tracking-tight text-gray-950">MIYZAN</span>
        <span class="text-xs font-medium uppercase tracking-[0.2em] text-emerald-600">
          {{ 'LOGIN.BRAND_TAG' | translate }}
        </span>
      </div>

      <!-- Auth card -->
      <div
        class="rounded-3xl border border-gray-100 bg-white p-6 shadow-xl shadow-gray-900/5 sm:p-8 lg:border-0 lg:bg-transparent lg:p-0 lg:shadow-none"
      >
        <!-- Heading -->
        <div class="mb-6 sm:mb-8">
          <span
            class="hidden lg:inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-emerald-600 ring-1 ring-emerald-100"
          >
            <span class="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
            {{ 'LOGIN.BADGE_LOGIN' | translate }}
          </span>
          <h2
            class="mt-0 lg:mt-3 text-[1.50rem] sm:text-[2rem] font-bold tracking-tight leading-tight text-gray-950"
          >
            {{ 'LOGIN.SUBTITLE' | translate }}
          </h2>
          <p class="mt-2 text-sm text-gray-500 leading-relaxed">
            {{ 'LOGIN.SIGN_IN_HINT' | translate }}
          </p>
        </div>

        <!-- Error -->
        @if (errorMessage()) {
          <div
            class="mb-5 rounded-2xl border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-600"
          >
            {{ errorMessage() }}
          </div>
        }

        <!--
          Parol yangilangani. Oyna yopilgandan keyin SHU YERDA ko'rinadi — xabar oyna
          ichida qolsa, foydalanuvchi uni yopishi bilan yo'qolib ketardi va nima
          bo'lganini bilmasdan qolardi.
        -->
        @if (resetDone()) {
          <div
            class="mb-5 rounded-2xl border border-emerald-100 bg-emerald-50 px-4 py-3 text-sm text-emerald-700 flex items-start gap-2"
          >
            <lucide-icon [img]="Check" class="h-4 w-4 mt-0.5 shrink-0"></lucide-icon>
            {{ resetDoneMsg() ?? ('LOGIN.RESET_DONE' | translate) }}
          </div>
        }

        <form (submit)="handleLogin($event)" class="space-y-4">
          <!-- Phone -->
          <div>
            <label for="phone" class="block text-sm font-semibold text-gray-700 mb-2">
              {{ 'LOGIN.PHONE' | translate }}
            </label>
            <div
              class="flex h-14 w-full overflow-hidden rounded-2xl border border-gray-200 bg-gray-50 focus-within:border-emerald-500 focus-within:bg-white focus-within:ring-4 focus-within:ring-emerald-500/10 transition-all"
            >
              <select
                name="phoneCode"
                [(ngModel)]="phoneCode"
                class="shrink-0 border-r border-gray-200 bg-transparent pl-4 pr-2 text-base sm:text-sm font-semibold text-gray-700 outline-none cursor-pointer"
              >
                <option value="+998">🇺🇿 +998</option>
                <option value="+7">🇷🇺 +7</option>
                <option value="+992">🇹🇯 +992</option>
                <option value="+993">🇹🇲 +993</option>
                <option value="+996">🇰🇬 +996</option>
                <option value="+994">🇦🇿 +994</option>
              </select>
              <input
                id="phone"
                name="localPhone"
                type="tel"
                placeholder="90 123 45 67"
                [(ngModel)]="localPhone"
                class="min-w-0 flex-1 bg-transparent px-4 text-base sm:text-sm text-gray-900 outline-none placeholder:text-gray-400"
                required
              />
            </div>
          </div>

          <!-- Password -->
          <div>
            <label for="password" class="block text-sm font-semibold text-gray-700 mb-2">
              {{ 'LOGIN.PASSWORD' | translate }}
            </label>
            <div class="relative">
              <lucide-icon
                [img]="Lock"
                class="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400 pointer-events-none"
              >
              </lucide-icon>
              <input
                id="password"
                name="password"
                [type]="showPassword() ? 'text' : 'password'"
                placeholder="••••••••"
                [(ngModel)]="loginData.password"
                class="h-14 w-full rounded-2xl border border-gray-200 bg-gray-50 pl-11 pr-12 text-base sm:text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:border-emerald-500 focus:bg-white focus:ring-4 focus:ring-emerald-500/10 transition-all"
                required
              />
              <button
                type="button"
                (click)="showPassword.set(!showPassword())"
                class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 transition"
              >
                <lucide-icon [img]="showPassword() ? EyeOff : Eye" class="h-4 w-4"></lucide-icon>
              </button>
            </div>
          </div>

          <!-- Submit -->
          <button
            type="submit"
            class="mt-2 flex h-14 w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-b from-emerald-500 to-emerald-700 px-4 text-base font-semibold text-white shadow-lg shadow-emerald-600/25 transition hover:from-emerald-400 hover:to-emerald-600 disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="isLoading()"
          >
            @if (isLoading()) {
              <span
                class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"
              ></span>
              {{ 'LOGIN.SIGNING_IN' | translate }}
            } @else {
              {{ 'LOGIN.SIGN_IN' | translate }}
              <lucide-icon [img]="ArrowRight" class="h-4 w-4"></lucide-icon>
            }
          </button>

          <button
            type="button"
            class="w-full text-center text-sm font-medium text-gray-400 hover:text-gray-700 transition pt-1"
            (click)="openReset()"
          >
            {{ 'LOGIN.RESET_WITH_OTP' | translate }}
          </button>
        </form>
      </div>
      <!-- /Auth card -->

      <!-- Trust footer -->
      <div class="mt-6 sm:mt-8 flex items-center justify-center gap-2 text-xs text-gray-400">
        <lucide-icon [img]="ShieldCheck" class="h-3.5 w-3.5 text-emerald-500"></lucide-icon>
        {{ 'LOGIN.TRUST' | translate }}
      </div>
    </div>
  </section>
</div>

<!--
  ─── Parolni tiklash — bitta oyna, ikki bosqich ───

  1-bosqich: telefon + "Kod yuborish".
  2-bosqich (kod yuborilgandan keyin): kod + yangi parol + "Parolni yangilash".

  Ilgari bu ikkita alohida oyna edi va kod so'raydiganini ochadigan tugma yo'q edi,
  shuning uchun foydalanuvchi kodni qayerdan olishini bilmasdi.
-->
<p-dialog
  [header]="'LOGIN.RESET_TITLE' | translate"
  [visible]="resetOpen()"
  (visibleChange)="resetOpen.set($event)"
  [modal]="true"
  [style]="{ width: '26rem', maxWidth: 'calc(100vw - 32px)' }"
>
  <!-- Bosqich ko'rsatkichi -->
  <div class="flex items-center gap-2 mb-4 text-xs">
    <span
      class="flex items-center justify-center w-6 h-6 rounded-full font-semibold"
      [class]="otpSent() ? 'bg-emerald-100 text-emerald-700' : 'bg-emerald-600 text-white'"
    >
      @if (otpSent()) {
        <lucide-icon [img]="Check" class="w-3.5 h-3.5" />
      } @else {
        1
      }
    </span>
    <span [class]="otpSent() ? 'text-gray-400' : 'text-gray-900 font-semibold'">
      {{ 'LOGIN.STEP_PHONE' | translate }}
    </span>

    <span class="flex-1 h-px bg-gray-200"></span>

    <span
      class="flex items-center justify-center w-6 h-6 rounded-full font-semibold"
      [class]="otpSent() ? 'bg-emerald-600 text-white' : 'bg-gray-100 text-gray-400'"
      >2</span
    >
    <span [class]="otpSent() ? 'text-gray-900 font-semibold' : 'text-gray-400'">
      {{ 'LOGIN.STEP_CODE' | translate }}
    </span>
  </div>

  @if (resetErr()) {
    <p class="text-sm text-red-600 mb-3">{{ resetErr() }}</p>
  }
  @if (resetMsg()) {
    <p class="text-sm text-emerald-700 mb-3">{{ resetMsg() }}</p>
  }

  @if (!otpSent()) {
    <!-- ── 1-bosqich: telefon ── -->
    <p class="text-xs text-gray-500 mb-3">{{ 'LOGIN.FORGOT_HINT' | translate }}</p>
    <div
      class="flex h-12 w-full rounded-xl border border-gray-200 bg-gray-50 overflow-hidden focus-within:ring-2 focus-within:ring-emerald-500 mb-4"
    >
      <select
        [(ngModel)]="resetPhoneCode"
        class="shrink-0 bg-transparent text-gray-700 text-sm px-3 border-r border-gray-200 outline-none font-semibold"
      >
        <option value="+998">🇺🇿 +998</option>
        <option value="+7">🇷🇺 +7</option>
        <option value="+992">🇹🇯 +992</option>
        <option value="+993">🇹🇲 +993</option>
        <option value="+996">🇰🇬 +996</option>
        <option value="+994">🇦🇿 +994</option>
      </select>
      <input
        type="tel"
        class="flex-1 min-w-0 px-3 text-sm bg-transparent text-gray-900 placeholder:text-gray-400 outline-none"
        [(ngModel)]="resetLocalPhone"
        placeholder="90 123 45 67"
      />
    </div>

    <div class="flex justify-end gap-2">
      <button
        type="button"
        pButton
        class="p-button-text"
        [label]="'LOGIN.CANCEL' | translate"
        (click)="resetOpen.set(false)"
      ></button>
      <button
        type="button"
        pButton
        [loading]="sendingOtp()"
        [disabled]="!canSendOtp()"
        [label]="'LOGIN.SEND_OTP' | translate"
        (click)="sendOtp()"
      ></button>
    </div>
  } @else {
    <!-- ── 2-bosqich: kod va yangi parol ── -->
    <div class="flex items-center justify-between mb-3">
      <p class="text-xs text-gray-500">
        {{ 'LOGIN.CODE_SENT_TO' | translate }}
        <span class="font-semibold text-gray-700">{{ resetPhoneCode }}{{ resetLocalPhone }}</span>
      </p>
      <button
        type="button"
        class="text-xs font-medium text-emerald-600 hover:text-emerald-700 shrink-0 ml-2"
        (click)="backToPhoneStep()"
      >
        {{ 'LOGIN.CHANGE_PHONE' | translate }}
      </button>
    </div>

    <div class="space-y-3 mb-4">
      <input
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        class="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm bg-gray-50 text-gray-900 tracking-widest focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:bg-white transition-all"
        [(ngModel)]="resetOtp"
        [placeholder]="'LOGIN.OTP' | translate"
      />

      <div class="relative">
        <input
          [type]="showResetPassword() ? 'text' : 'password'"
          autocomplete="new-password"
          class="w-full border border-gray-200 rounded-xl px-4 py-3 pr-11 text-sm bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:bg-white transition-all"
          [(ngModel)]="resetPassword"
          [placeholder]="'LOGIN.NEW_PASSWORD' | translate"
        />
        <button
          type="button"
          (click)="showResetPassword.set(!showResetPassword())"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition"
        >
          <lucide-icon [img]="showResetPassword() ? EyeOff : Eye" class="w-4 h-4"></lucide-icon>
        </button>
      </div>

      <!--
        Tasdiqlash maydoni: parol yopiq yozilgani uchun xato terilgan bo'lsa,
        foydalanuvchi buni faqat keyingi kirishda — kirolmay qolganda bilardi.
      -->
      <input
        [type]="showResetPassword() ? 'text' : 'password'"
        autocomplete="new-password"
        class="w-full border rounded-xl px-4 py-3 text-sm bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:bg-white transition-all"
        [class]="
          passwordsMismatch()
            ? 'border-red-300 focus:ring-red-500'
            : 'border-gray-200 focus:ring-emerald-500'
        "
        [(ngModel)]="resetPasswordConfirm"
        [placeholder]="'LOGIN.CONFIRM_PASSWORD' | translate"
      />
      @if (passwordsMismatch()) {
        <p class="text-xs text-red-600">{{ 'LOGIN.PASSWORD_MISMATCH' | translate }}</p>
      }
    </div>

    <div class="flex justify-end gap-2">
      <button
        type="button"
        pButton
        class="p-button-text"
        [label]="'LOGIN.CANCEL' | translate"
        (click)="resetOpen.set(false)"
      ></button>
      <button
        type="button"
        pButton
        [loading]="resetting()"
        [disabled]="!canReset()"
        [label]="'LOGIN.UPDATE_PASSWORD' | translate"
        (click)="submitReset()"
      ></button>
    </div>
  }
</p-dialog>
